export const DEFAULT_META_DESCRIPTION =
  'A Qualidoc é uma farmácia online brasileira que comercializa medicamentos, genéricos, dermocosméticos e produtos de saúde, com entrega no Brasil.';

/** Used with DefaultSeo titleTemplate `%s | Qualidoc`. */
export const HOME_META_TITLE =
  'Farmácia Online 24 horas | Medicamentos e saúde';

export const HOME_H1 = 'Farmácia online Qualidoc';

export const HOME_META_DESCRIPTION =
  'Compre medicamentos, genéricos, dermocosméticos e produtos de saúde na Qualidoc, farmácia online com entrega em todo o Brasil.';

export function categoryMetaDescription(
  categoryName: string,
  description?: string | null,
): string {
  const fromCms = description?.trim();
  if (fromCms) return fromCms;
  return `Compre ${categoryName} com o melhor preço e entrega rápida na Qualidoc Farmácia. Frete grátis, cashback e produtos de qualidade.`;
}

export function typeMetaDescription(typeName: string): string {
  return `Compre ${typeName} com o melhor preço e entrega rápida na Qualidoc, farmácia online com entrega em todo o Brasil.`;
}
